import fertigationDataConfig from '@/api/config/fertigationDataConfig'
import { queryKeys } from '@/constant/common'
import { EditFertigation } from '@/types/fertigation'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import toast from 'react-hot-toast'
import { useConfigUI } from '../../context'
import useTranslation from '@/hooks/useTranslation'

async function update(payload: EditFertigation): Promise<void> {
  await fertigationDataConfig.edit(payload)
}

function useUpdateFertigation() {
  const { t } = useTranslation()
  const queryClient = useQueryClient()
  const { closeSidebar } = useConfigUI()

  return useMutation((payload: EditFertigation) => update(payload), {
    onSuccess: () => {
      queryClient.invalidateQueries([queryKeys.fertigation])
      toast.success(t('updateFertigationSuccess'))
      closeSidebar()
    },
    onError: (error: any) => {
      if (error?.statusCode === 400) {
        toast.error(error?.message)
      } else toast.error(t('updateFertigationError'))
    },
  })
}

export default useUpdateFertigation
